import { render, staticRenderFns } from "./ReplacementItem.vue?vue&type=template&id=42633948&scoped=true&"
import script from "./ReplacementItem.vue?vue&type=script&lang=js&"
export * from "./ReplacementItem.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementItem.vue?vue&type=style&index=0&id=42633948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42633948",
  null
  
)

export default component.exports